// extracted by mini-css-extract-plugin
module.exports = {"background":"Z_dW","shopping__wrapper__examples":"Z_d8","active":"Z_d9","shopping__wrapper__project":"Z_fb"};